import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'

interface EmptyStateProps {
  icon?: ReactNode
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="text-center py-12 px-6">
      <div className="inline-flex w-14 h-14 bg-slate-100 rounded-xl items-center justify-center mb-3 text-slate-500">
        {icon ?? <Inbox className="w-7 h-7" />}
      </div>
      <h3 className="font-display text-xl text-navy-700">{title}</h3>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
